<script lang="ts" setup>
// NOTE: Initial image-based approach for review rubric, with proper scaling based on screen size
//         BUT requiring manual updates when rubric changed (not dynamic).
//       Image can be generated/updated via screenshot from Google Docs (cropped to table border).

interface ReviewRubricImageProps {
  image: string;
}

withDefaults(defineProps<ReviewRubricImageProps>(), {});
</script>

<template>
  <VImg alt="Review rubric" :src="image" />
</template>
